// Forever Foods Theme JavaScript
// Handles animations, interactions, and scroll effects

document.addEventListener('DOMContentLoaded', function() {
  // Initialize scroll animations
  initScrollAnimations();

  // Header scroll is handled by inline script in ff-header.liquid section
  // Do NOT initialize here to avoid duplicate scroll listeners

  // Mobile menu is handled by inline script in ff-header.liquid section
  // Do NOT initialize here to avoid double-toggle conflict

  // FAQ accordion is handled by inline script in ff-faq.liquid section
  // Do NOT initialize here to avoid double-toggle conflict
});

// Scroll animations with Intersection Observer
function initScrollAnimations() {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const element = entry.target;

        // Add visible class to trigger animation (matches section inline scripts)
        if (element.classList.contains('fade-in')) {
          element.classList.add('visible');
        }

        // Apply animation based on data attribute
        if (element.dataset.animate) {
          element.style.animation = element.dataset.animate;
        }

        // Stop observing after animation
        observer.unobserve(element);
      }
    });
  }, {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  });

  // Observe all elements with animation classes
  document.querySelectorAll('.fade-in, [data-animate]').forEach(el => {
    observer.observe(el);
  });
}

// Header scroll effect
function initHeaderScroll() {
  const header = document.querySelector('[data-header]') || document.querySelector('.ff-header-wrapper');
  if (!header) return;

  let lastScrollTop = 0;
  let ticking = false;

  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (scrollTop > 50) {
          header.classList.add('scrolled');
        } else {
          header.classList.remove('scrolled');
        }

        lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
        ticking = false;
      });
      ticking = true;
    }
  });
}

// Mobile menu toggle
function initMobileMenu() {
  const toggle = document.querySelector('[data-menu-toggle]') || document.getElementById('ffNavToggle');
  const menu = document.querySelector('[data-mobile-menu]') || document.getElementById('ffMobileMenu');
  const header = document.querySelector('[data-header]') || document.querySelector('.ff-header-wrapper');

  if (!toggle || !menu) return;

  toggle.addEventListener('click', (e) => {
    e.preventDefault();
    toggle.classList.toggle('active');
    menu.classList.toggle('active');
    document.body.classList.toggle('ff-no-scroll');
  });

  // Close menu on link click
  const menuLinks = menu.querySelectorAll('a');
  menuLinks.forEach(link => {
    link.addEventListener('click', () => {
      toggle.classList.remove('active');
      menu.classList.remove('active');
      document.body.classList.remove('ff-no-scroll');
    });
  });

  // Highlight active link
  const currentPath = window.location.pathname;
  menuLinks.forEach(link => {
    const href = link.getAttribute('href');
    if (href === currentPath || (currentPath === '/' && href === '/')) {
      link.classList.add('active');
    }
  });
}

// FAQ Accordion
function initFAQAccordion() {
  const faqItems = document.querySelectorAll('[data-faq-item]');

  faqItems.forEach(item => {
    const toggle = item.querySelector('[data-faq-toggle]');
    if (toggle) {
      toggle.addEventListener('click', () => {
        item.classList.toggle('active');
      });
    }
  });
}

// Smooth scroll behavior
if (document.documentElement.style.scrollBehavior === undefined) {
  document.documentElement.style.scrollBehavior = 'smooth';
}

// Utility: Lazy load images with placeholder
function lazyLoadImages() {
  const images = document.querySelectorAll('img[data-src]');

  const imageObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const img = entry.target;
        img.src = img.dataset.src;
        img.removeAttribute('data-src');
        imageObserver.unobserve(img);
      }
    });
  });

  images.forEach(img => imageObserver.observe(img));
}

// Utility: Add active class to navigation links based on current page
function updateActiveNavLinks() {
  const currentPath = window.location.pathname;
  const navLinks = document.querySelectorAll('.ff-nav-links a, [data-nav-link]');

  navLinks.forEach(link => {
    const href = link.getAttribute('href');
    if (href === currentPath) {
      link.classList.add('active');
    } else {
      link.classList.remove('active');
    }
  });
}

// Initialize active nav links on page load and history change
updateActiveNavLinks();
window.addEventListener('popstate', updateActiveNavLinks);

// Prevent layout shift when scrollbar appears/disappears
(function() {
  const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
  if (scrollbarWidth > 0) {
    document.documentElement.style.setProperty('--scrollbar-width', scrollbarWidth + 'px');
  }
})();